module.exports = __webpack_public_path__ + "img/logo.ba504ca4.jpg";